import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { Observable } from 'rxjs';
import { IdinIssuerDto } from '../model/business/application/IdinIssuerDto';
import { AuthenticationRequestDto } from '../model/business/application/AuthenticationRequestDto';
import { IdinRequestDto } from '../model/business/application/IdinRequestDto';
import { ValidateApplicationDataDto } from '../model/business/application/ValidateApplicationDataDto';
import { AuthenticationResponseDto } from '../model/business/application/AuthenticationResponseDto';
import { StatusResponseDto } from '../model/business/application/StatusResponseDto';
import { RequestOptions } from '../model/RequestOptions';

@Injectable({
  providedIn: 'root',
})
export class IdinService {
  constructor(private httpService: HttpService) {}

  getDirectoryIssuersList(): Observable<Array<IdinIssuerDto>> {
    return this.httpService.get('idinRequests/getDirectoryIssuersList');
  }

  postAuthenticateRequest(
    authenticationRequestDto: AuthenticationRequestDto
  ): Observable<IdinRequestDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    return this.httpService.post(
      'idinRequests/authenticateRequest',
      authenticationRequestDto,
      null,
      requestOptions
    );
  }

  validateApplicationDataRequest(
    validateApplicationDataDto: ValidateApplicationDataDto
  ): Observable<ValidateApplicationDataDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    return this.httpService.post(
      'idinRequests/validateApplicationDataRequest',
      validateApplicationDataDto,
      null,
      requestOptions
    );
  }

  getStatusResponse(transactionID: string): Observable<StatusResponseDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    return this.httpService.get<any>(
      'idinRequests/statusResponse',
      {
        transactionID: transactionID,
      },
      requestOptions
    );
  }

  postIdinTransaction(idinRequestDto: IdinRequestDto) {
    return this.httpService.post(
      'idinRequests/saveIdinTransaction',
      idinRequestDto
    );
  }
}
